import { createSelector } from '@reduxjs/toolkit';

import { flattenTree, findNodeContext } from '../../lib/taxonomy';

export const selectTaxonomyTree = (state) => state.taxonomy.tree;
export const selectTaxonomyVersion = (state) => state.taxonomy.version;
export const selectTaxonomyLoading = (state) => state.taxonomy.loading;
export const selectTaxonomySaving = (state) => state.taxonomy.saving;
export const selectTaxonomyError = (state) => state.taxonomy.error;
export const selectSelectedNodeId = (state) => state.taxonomy.selectedNodeId;
export const selectAttributeDefinitions = (state) => state.taxonomy.attributes;
export const selectAttributesError = (state) => state.taxonomy.attributesError;

/** Selected node plus its sibling list - the editor and drag maths need both. */
export const selectSelectedNodeContext = createSelector(
  [selectTaxonomyTree, selectSelectedNodeId],
  (tree, id) => (id ? findNodeContext(tree, id) : null)
);

export const selectFlatTaxonomyNodes = createSelector([selectTaxonomyTree], (tree) =>
  flattenTree(tree)
);

export const selectUsedBehaviorKeys = createSelector([selectTaxonomyTree], (tree) =>
  tree.map((node) => node.behavior_key).filter(Boolean)
);
